<div class="settings-row" [ngClass]="{'highlight': data.enabled}">
  <div class="row-content" [ngClass]="{'app-col-name':isAppSetting, 'col-name':!isAppSetting}">
    {{data.eventIdentifier}}
  </div>

  <div class="setting_toggle col-enabled">
    <bfx-toggle [(ngModel)]="data.enabled" (ngModelChange)="pageDataChanged()"></bfx-toggle>
  </div>
  @if( isAppSetting){
  <div class="setting_toggle col-return-at-login">
    @if(data.returnOnLogin != null){
    <bfx-toggle [(ngModel)]="data.returnOnLogin" (ngModelChange)="pageDataChanged()"></bfx-toggle>
    }
  </div>
  }
  <div class="user-settings-control col-audio">
    <bfx-autoComplete
      appendTo="body"
      size="sm"
      [ngModel]="data.audio"
      [suggestions]="audioSuggestions"
      (completeMethod)="searchAudios($event)"
      (ngModelChange)="onChangeAudio($event)"
      [dropdown]="true"
      [disabled]="!data.enabled || audioDisabled()"
      autoHighlight="true"
      delay="4"
      field="label"
      dataKey="value"
      [minLength]="0"
      [maxlength]="50"
      [style]="{'width':'100%'}"
      (onBlur)="onBlurAudio($event)"
      [tooltipOnItem]="true"
      [skipSorting]="true"
      [allowEmptySelection]="false"
      [settingsCorrection]="true"
    ></bfx-autoComplete>
  </div>
  <div class="user-settings-control col-filter">
    <bfx-autoComplete
      [hidden]="data.filterList?.length == 1"
      appendTo="body"
      size="sm"
      [(ngModel)]="data.filter"
      [suggestions]="filterSuggestions"
      (completeMethod)="searchFilters($event)"
      (onSelect)="onSelectFilter($event)"
      [dropdown]="true"
      [disabled]="!data.enabled"
      autoHighlight="true"
      delay="4"
      field="name"
      dataKey="id"
      [minLength]="0"
      [maxlength]="50"
      [style]="{'width':'100%'}"
      (onBlur)="onBlurFilter($event)"
      [tooltipOnItem]="true"
      [skipSorting]="true"
      [allowEmptySelection]="false"
      [settingsCorrection]="true"
    ></bfx-autoComplete>
  </div>
</div>
